import { render } from "./VerticalContainer.vue.js?vue&type=template&id=7cb2abe5!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainer.vue?vue&type=template&id=7cb2abe5"
import script from "./VerticalContainer.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainer.vue?vue&type=script&lang=js"
export * from "./VerticalContainer.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/elements/layouts/VerticalContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cb2abe5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cb2abe5', __exports__)) {
    api.reload('7cb2abe5', __exports__)
  }
  
  module.hot.accept("./VerticalContainer.vue.js?vue&type=template&id=7cb2abe5!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainer.vue?vue&type=template&id=7cb2abe5", () => {
    api.rerender('7cb2abe5', render)
  })

}


export default __exports__